import PronunciationAssessmentDetailView from "@features/tools/view/pronunciation-assessment-view/pronunciation-assessment-detail-view";

const PronunciationAssessmentDetail = () => {
  return <PronunciationAssessmentDetailView />;
};

export default PronunciationAssessmentDetail;
